import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersBatchManagementVM } from 'system/view-models/batch-managment/filters-vm';

interface FiltersBatchManagementProps {
  filterBatchForm: FormikProps<FiltersBatchManagementVM>;
}

const FilterBatchManagementComponent = ({
  filterBatchForm,
}: FiltersBatchManagementProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-batch-content"
        id="panel-batch-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterBatchForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Nome batch"
                label="Nome batch"
                id="batchName"
                name="batchName"
                fullWidth
                type="text"
                variant="outlined"
                value={filterBatchForm.values.batchName || ''}
                onChange={filterBatchForm.handleChange}
                error={
                  filterBatchForm.touched.batchName && Boolean(filterBatchForm.errors.batchName)
                }
                helperText={filterBatchForm.errors.batchName}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione"
                label="Descrizione"
                id="batchDescription"
                name="batchDescription"
                fullWidth
                type="text"
                variant="outlined"
                value={filterBatchForm.values.batchDescription || ''}
                onChange={filterBatchForm.handleChange}
                error={
                  filterBatchForm.touched.batchDescription &&
                  Boolean(filterBatchForm.errors.batchDescription)
                }
                helperText={filterBatchForm.errors.batchDescription}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterBatchForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterBatchManagementComponent.displayName = 'Filters Batch management';

const FilterBatchManagement = memo(FilterBatchManagementComponent);

export default FilterBatchManagement;
